import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { ICountry, IForgotState, Recovery } from "../../../utils/types";
import { useTranslation } from "react-i18next";
import "../stylePage.css";
import ModalSmall from "../../components/ModalSmall";
import { ForgotPassword } from "../../../services/UserAuthService";
import logoSmall from "../../../assets/custom/classic/logo_login_small.svg";
import * as BsIcons from "react-icons/bs"; 

 
const ForgotPasswordForm = ({
  countries,
  forgotState,
}: {
  countries: ICountry[];
  forgotState: IForgotState;
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);
  const [recovery, setRecovery] = useState<Recovery>({ email: "" } as Recovery);
 
  const [error, setError] = useState<boolean>(false);
  const [msgError, setMsgError] = useState<string>("");
  const [info, setInfo] = useState<boolean>(false);
  const [msgInfo, setMsgInfo] = useState<string>("");
  const [selectedValueCountry, setSelectedValueCountry] = useState<number>(1);

  async function handleSend() {
    setLoading(true);
    setMsgError("");
    setMsgInfo("");
    try {
      let country = countries.find(
        (country) => country.CountryID === recovery.countryID
      );
      const response = await ForgotPassword(
        recovery.email,
        recovery.countryID ?? country?.CountryID ?? 0,
        t("locale")
      );  
      if (response?.data?.Code > 0) {
        setMsgInfo(response.data?.Message?.ErrorMessage);
        setInfo(true);
        recovery.email = "";  
      }  
      setTimeout(() =>  forgotState.setClickedForgot(false), 5000);    
    } catch (error) { 
      setMsgInfo(t("password.submit.errorTitle"));
      setInfo(true);
    } finally {
      setLoading(false);
    }
  }

  function handleCancel() {
    recovery.email = "";
    forgotState.setClickedForgot(false);
  }

  return (
    <>
      <div className="login-container">
        <div className="login-form-wrapper">
          <div className="login-form-card">
            {/* Logo e Header */}
            <div className="login-form-header">
              <img src={logoSmall} alt="IBOPE" className="login-logo" />
              <h1 className="login-title">{t("password.forgotPasswordTitle")}</h1>
              
            </div>

            <form className="login-form">
              {/* Email Input */}
              <div className="login-input-group">
                
                <input
                  className="loginInput"
                  placeholder={t("password.email")}
                  type="email"
                  value={recovery.email}
                  onChange={(e) =>
                    setRecovery((prev) => ({ ...prev, email: e.target.value }))
                  }
                />
              </div>

              {/* Country Select */}
              <div className="login-input-group">
                <Form.Select
                  className="login-select"
                  onChange={(e) => {
                    setRecovery((prev) => ({
                      ...prev,
                      countryID: parseInt(e.target.value),
                    }));
                    setSelectedValueCountry(parseInt(e.target.value));
                  }}
                  value={selectedValueCountry}
                >
                  {countries.map((option) => (
                    <option key={option.CountryID} value={option.CountryID}>
                      {option.CountryDesc}
                    </option>
                  ))}
                </Form.Select>
              </div>

              {/* Botões */}
              <div className="forgot-buttons-row">
                <Button
                  className="button"
                  onClick={handleSend}
                  disabled={loading || !recovery.email}
                >
                  {loading ? t("login.submit.loading") || "Sending..." : t("password.submit.send")}
                </Button>
                <Button
                  variant="secondary"
                  className="btn-secondary"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  {t("password.cancel")}
                </Button>
              </div>

              
            </form>
          </div>
        </div>
      </div>

      <ModalSmall
        showModal={error}
        setShowModal={setError}
        title={t("password.submit.errorTitle")}
        text={msgError}
        type="modal-danger"
      />
      <ModalSmall
        showModal={info}
        setShowModal={setInfo}
        title={t("password.submit.WarnTitle")}
        text={msgInfo}
        type="modal-warn"
      />
    </>
  );
};

export default ForgotPasswordForm;
